module.exports = __webpack_public_path__ + "static/media/auto.6978a9cb.svg";